<template>
    <Head :title="t('peopleDirectory.createTeam.title')" />
    <BaseLayout gap="lg" class="fs-mask">
        <TeamCreateForm
            :source="source"
            :creator="creator"
            :search-url="search_url"
            :create-url="create_url"
            :team-url-template="team_url_template"
            :recommendations-url="recommendations_url"
            :back-url="back_url"
            @selected="openTeam($event.url)" />
        <BaseNotification theme="error" hide-dismiss class="empty:sr-only">
            <template #content>
                <div v-if="failedTeamUrl" class="flex flex-col items-start gap-2">
                    <p class="body-small">{{ t("peopleDirectory.createTeam.openError") }}</p>
                    <BaseLink :href="failedTeamUrl" class="base-link">{{ t("peopleDirectory.retry") }}</BaseLink>
                </div>
            </template>
        </BaseNotification>
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3";
import { useUrlSearchParams } from "@vueuse/core";
import type { TeamCreatePage } from "~vue/api/generated/team-perspective/types.gen";
import BaseLayout from "~vue/components/BaseLayout.vue";
import BaseNotification from "~vue/components/BaseNotification.vue";
import TeamCreateForm from "~vue/Connections/TeamCreateForm.vue";
import BaseLink from "~vue/router/BaseLink.vue";
import { TEAM_INTERACTION_SOURCE } from "~vue/Teams/teamInteraction";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

defineProps<TeamCreatePage>();
const { t } = useI18n();
const failedTeamUrl = ref<string | null>(null);
const parameters = useUrlSearchParams("history", { write: false });
const source = computed(() => Object.values(TEAM_INTERACTION_SOURCE).find((value) => value === parameters.team_source) ?? TEAM_INTERACTION_SOURCE.MY_PEOPLE);

function openTeam(url: string) {
    failedTeamUrl.value = null;
    let succeeded = false;
    router.visit(url, {
        onSuccess: () => {
            succeeded = true;
        },
        onFinish: () => {
            if (!succeeded) {
                failedTeamUrl.value = url;
            }
        },
    });
}
</script>
